import RentalListPage from "../common/Rentals/RentalListPage";
import AddUnit from "./add";
import TableRow from "./row";

const UNITS_CONFIG = {
  pageTitle: "Units",
  addButtonLabel: "Unit",
  emptyMessage: "No units matching your current search or filters.",
  sortOptions: ["updated_at", "pms_id"],
  hasFilters: false,
  extraButtons: [
    { label: "Property Field Values", href: "/property-field-values" }
  ],
  ShowShareComponent: false,
  AddComponent: AddUnit,
  RowComponent: TableRow,
};

export default () => <RentalListPage config={UNITS_CONFIG} />;